import React, { useState, useEffect } from 'react';

const PdfImg = 'content/images/PDF_file_icon.png';
// images are served from the backend on port 8082 when running locally, and from the same origin otherwise
const isLocalhost = ['localhost', '127.0.0.1'].includes(window.location.hostname);
const baseImageUrl = isLocalhost ? 'http://localhost:8082/image' : '/image';
export const baseProfileImageUrl = isLocalhost ? 'http://localhost:8082/profile/get/image' : '/profile/get/image';

const allowedImageExt = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
const allowedVideoExt = ['mp4', 'mov', 'webm', 'ogg', 'avi', 'mkv', 'mp3'];
const allowedPdfExt = ['pdf'];
const fileSize = 50 * 1024 * 1024;

// -------------- VALIDATION --------------
export const checkValid = (event: React.ChangeEvent<HTMLInputElement>): string | null => {
  const selectedFile = event.target.files?.[0];

  if (!selectedFile) return null;

  // Size Check
  if (selectedFile.size > fileSize) {
    return 'File size must be less than 50MB';
  }

  const ext = selectedFile.name.split('.').pop()?.toLowerCase() || '';

  const isValid = allowedImageExt.includes(ext) || allowedVideoExt.includes(ext) || allowedPdfExt.includes(ext);

  if (!isValid) {
    return `Unsupported file format .${ext}`;
  }

  return null;
};

// Returns an error message when `value` has more than `maxWords` words, otherwise null
export const validateWordLimit = (value: string, maxWords: number, label: string): string | null => {
  const wordCount = value.trim() ? value.trim().split(/\s+/).length : 0;
  return wordCount > maxWords ? `Only ${maxWords} words are allowed in ${label}` : null;
};

// -------------- VIDEO FALLBACK COMPONENT --------------
const VideoWithFallback = ({ url }: { url: string }) => {
  const [error, setError] = useState(false);
  useEffect(() => {
    setError(false);
  }, [url]);
  if (error) {
    return (
      <div className="img-thumbnail mb-4 p-0">
        <div
          style={{
            padding: '20px',
            background: '#ffeeee',
            color: '#d00',
            borderRadius: '6px',
          }}
        >
          <strong>Video format not supported by your browser.</strong>
          <br />
          <a href={url} target="_blank" style={{ color: '#0056d2' }}>
            Click here to download and view the video
          </a>
        </div>
      </div>
    );
  }

  return (
    <video
      controls
      key={url}
      src={url}
      className="mb-4 p-0"
      style={{ width: '100%', maxHeight: '300px' }}
      onCanPlay={() => setError(false)}
      onError={e => {
        console.log('Video failed to load', e);
        setError(true);
      }}
    />
  );
};

// -------------- PREVIEW RENDERER --------------
export const renderPreview = (fileName: string): JSX.Element | null => {
  if (!fileName) return null;

  const url = `${baseImageUrl}/${fileName}`;
  const ext = fileName.split('.').pop()?.toLowerCase() || '';
  console.log('ext :', ext);

  // IMAGE
  if (allowedImageExt.includes(ext)) {
    return <img className="img-thumbnail mb-4 p-0" src={url} alt="preview" />;
  }

  // VIDEO
  if (allowedVideoExt.includes(ext)) {
    return <VideoWithFallback url={url} />;
  }

  // PDF
  if (allowedPdfExt.includes(ext)) {
    return (
      <div onClick={() => window.open(url, '_blank')} style={{ cursor: 'pointer' }}>
        <img src={PdfImg} className="img-thumbnail mb-4 p-0 pdfImg" alt="pdf" />
      </div>
    );
  }

  return <p>Unsupported file format</p>;
};

export const isValidUrl = value => {
  try {
    const url = new URL(value);
    return ['http:', 'https:'].includes(url.protocol);
  } catch {
    return false;
  }
};
